import { render, staticRenderFns } from "./TabDetalle.vue?vue&type=template&id=063245a7&"
import script from "./TabDetalle.vue?vue&type=script&lang=ts&"
export * from "./TabDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('063245a7', component.options)
    } else {
      api.reload('063245a7', component.options)
    }
    module.hot.accept("./TabDetalle.vue?vue&type=template&id=063245a7&", function () {
      api.rerender('063245a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/tabs/TabDetalle.vue"
export default component.exports